import * as React from 'react';
import { observer } from 'mobx-react';
import { ProductTout } from '../product-tout/ProductTout';
import { configConsumer } from '@estee/elc-service';
import { IProductBriefConfig, IProductBriefProps } from '~interfaces/IProductBrief';
import ProductBrief from 'src/exported/product-brief/ProductBrief';

export enum CollectionItemType {
    PRODUCT = 'product',
    TOUT = 'tout',
    FEATURED_PRODUCT = 'featured'
}

export interface ICollectionItemProps {
    collectionItem: CollectionItemType;
    productBriefProps?: IProductBriefProps;
    id: number | string;
    config?: IProductBriefConfig;
}

@configConsumer([
    'componentElementsOrderConfig',
    'enableClickableBrief',
    'productBenefitTypes',
    'translationsOverwrites',
    'imageCarouselSettings'
])
@observer
export class CollectionItem extends React.Component<ICollectionItemProps> {
    public static displayName: string;

    public getBrief() {
        const props = {
            config: {
                ...(this.props.productBriefProps as IProductBriefProps),
                ...this.props.config
            }
        };

        return <ProductBrief {...props} />;
    }

    render() {
        const { collectionItem, id } = this.props;

        switch (collectionItem) {
            case CollectionItemType.PRODUCT:
                return this.getBrief();
            case CollectionItemType.TOUT:
                return <ProductTout nid={id as number} />;
            default:
                return null;
        }
    }
}

CollectionItem.displayName = 'CollectionItem';
